import { SVGProps } from "react";

const IconAnalyze = (props: SVGProps<SVGSVGElement>) => {
    const { className, ...rest } = props;

    return (
        <svg
            className={className}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            {...rest}
        >
            <rect
                x="1"
                y="3"
                width="20"
                height="14"
                rx="1"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <path
                d="M6.38281 11.3262C6.9351 11.3262 7.38281 10.8785 7.38281 10.3262C7.38281 9.77389 6.9351 9.32617 6.38281 9.32617C5.83053 9.32617 5.38281 9.77389 5.38281 10.3262C5.38281 10.8785 5.83053 11.3262 6.38281 11.3262Z"
                fill="currentColor"
            />
            <path
                d="M9.16895 12.4294C9.72123 12.4294 10.1689 11.9817 10.1689 11.4294C10.1689 10.8772 9.72123 10.4294 9.16895 10.4294C8.61666 10.4294 8.16895 10.8772 8.16895 11.4294C8.16895 11.9817 8.61666 12.4294 9.16895 12.4294Z"
                fill="currentColor"
            />
            <path
                d="M15.0439 11.1289C15.5962 11.1289 16.0439 10.6812 16.0439 10.1289C16.0439 9.57662 15.5962 9.12891 15.0439 9.12891C14.4917 9.12891 14.0439 9.57662 14.0439 10.1289C14.0439 10.6812 14.4917 11.1289 15.0439 11.1289Z"
                fill="currentColor"
            />
            <path
                d="M12.1562 9C12.7085 9 13.1562 8.55228 13.1562 8C13.1562 7.44772 12.7085 7 12.1562 7C11.604 7 11.1562 7.44772 11.1562 8C11.1562 8.55228 11.604 9 12.1562 9Z"
                fill="currentColor"
            />
            <path
                d="M18 8C18.5523 8 19 7.55228 19 7C19 6.44771 18.5523 6 18 6C17.4477 6 17 6.44771 17 7C17 7.55228 17.4477 8 18 8Z"
                fill="currentColor"
            />
            <path
                d="M3.75391 6V12.8289M18.2471 14.2732H3.75391V12.8289M3.75391 12.8289L6.34253 10.2379L9.21053 11.6572L12.1511 7.82649L15.1049 10.2379L17.8701 6.92547"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <line
                x1="6.25"
                y1="20.2415"
                x2="15.75"
                y2="20.2415"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default IconAnalyze;
